/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect} from 'react'
import {Outlet, Route, Routes} from 'react-router-dom'
import {Login} from './components/Login'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import { useSelector } from 'react-redux'
import Favicon from 'react-favicon'

const AuthLayout = () => {
  const customerInfo = useSelector(({auth}: any) => auth.customerInfo)

  useEffect(() => {
    document.body.classList.add('bg-white')
    return () => {
      document.body.classList.remove('bg-white')
    }
  }, [])

  const raw = customerInfo.appletLoginNotes?.replaceAll('\n', ' \n ')
  const splitted = raw?.split(' ');

  const validURL = (str) => {
    var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
    '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
    return !!pattern.test(str);
  }

  const parsed = splitted?.map((p, i) => {
    let e = p;
    if (validURL(p)) {
      e = <a href={p} target="_blank" rel='noreferrer'>{p}</a>;
    }else if (p === '\n'){
      e = <br/>
    }

    return <>{e}{(i === splitted.length) ? '' : ' '}</>;
  });

  return (
    <div
      className='d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed'
      style={customerInfo?.portalBackground.includes('#') ? {
        backgroundSize: 'cover',
        backgroundColor: customerInfo?.portalBackground,
        backgroundPosition: customerInfo?.loginWindowPositionPortal === 'Left' ? 'right' : 'left'
      } : {
        backgroundImage: customerInfo?.portalBackground,
        backgroundSize: 'cover',
        backgroundPosition: customerInfo?.loginWindowPositionPortal === 'Left' ? 'right' : 'left'
      }}
    >
      {customerInfo.customFavIcon && (
        <Favicon url={customerInfo.customFavIcon} animated={false}/>
      )}
      {/* begin::Content */}
      <div className={`d-flex ${window.innerWidth > 991 ? customerInfo.loginWindowPositionPortal === 'Left' ? 'align-items-start' : customerInfo.loginWindowPositionPortal === 'Right' ? 'align-items-end' : 'align-items-center' : 'align-items-center'} justify-content-center flex-column flex-column-fluid ${window.innerWidth > 991 ? customerInfo.loginWindowPositionPortal === 'Left' ? 'ms-9' : customerInfo.loginWindowPositionPortal === 'Right' ? 'me-9' : '' : ''} ${window.innerHeight < 676 ? 'p-4' : 'p-10 pb-lg-20'}`}>
        {/* begin::Logo */}
        <div className='w-lg-500px d-flex justify-content-center'>
          <div className={`${window.innerHeight < 676 ? 'mb-2' : 'mb-12'}`}>
            <img alt='Logo' src={toAbsoluteUrl(customerInfo?.portalMainLogo)}/>
          </div>
        </div>
        {/* end::Logo */}
        {/* begin::Wrapper */}
        <div className={`w-lg-500px bg-white rounded shadow-sm ${window.innerHeight < 676 ? 'p-7' : 'p-10 p-lg-15'}`}>
          <Outlet />
        </div>
        {/* end::Wrapper */}

        {
          customerInfo.appletLoginNotes ? <div className={`w-350px w-lg-500px bg-white rounded shadow-sm mt-3 ${window.innerHeight < 676 ? 'p-2' : 'p-5'}`} style={{textAlign: 'center', overflow: 'line-break'}}>
            <div style={{overflowWrap: 'anywhere'}}>
              {parsed}
            </div>
          </div>
          : null
        }
        
      </div>
      {/* end::Content */}
      {/* begin::Footer */}
      <div className={`d-flex ${window.innerWidth > 991 ? customerInfo.loginWindowPositionPortal === 'Left' ? 'justify-content-start' : customerInfo.loginWindowPositionPortal === 'Right' ? 'justify-content-end' : 'justify-content-center' : 'justify-content-center'} flex-column-auto p-10 ${window.innerWidth > 991 ? customerInfo.loginWindowPositionPortal === 'Left' ? 'ms-9' : customerInfo.loginWindowPositionPortal === 'Right' ? 'me-9' : '' : ''}`}>
        <div className='w-lg-500px d-flex justify-content-center'>
          <div className='d-flex align-items-center fw-bold fs-6'>
            <div className="text-white">Powered by</div> <img alt='Shipprimus logo' src={process.env.PUBLIC_URL+'/media/logos/favicon.ico'} className='h-30px'/> <a href='https://www.shipprimus.com' target="_blank" rel="noopener noreferrer" className='text-white text-hover-primary'>Shipprimus.com</a>
          </div>
        </div>
      </div>
      {/* end::Footer */}
    </div>
  )
}

const AuthPage = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      <Route path='login' element={<Login />} />
      <Route index element={<Login />} />
    </Route>
  </Routes>
)

export {AuthPage}
